<div class="bg-white rounded-tl-lg rounded-tr-lg text-dark-grey overflow-hidden">
  <app-modal-header
    [title]="title()"
    iconPath="assets/icons/calendar-dots-light.svg"
  />

  <mat-dialog-content>
    <div class="flex flex-col gap-6 mb-20">
      <form>
        <app-input
          type="text"
          label="Email"
          [control]="form.controls.email"
        />

        <app-input
          type="text"
          label="Vorname"
          [control]="form.controls.firstname"
        />
        <app-input
          type="text"
          label="Nachname"
          [control]="form.controls.lastname"
        />
        <app-radio-group-with-label
          label="Gender"
          [options]="genderOptions"
          [control]="form.controls.gender"
        />
      </form>

      <div class="w-full flex flex-col relative">
        @for (user of users(); track user) {
          <div
            class="w-full flex justify-between items-center p-1 border-y border-light-grey text-sm"
            [class.bg-light-grey]="isSelected(user.id)"
            [class.opacity-50]="user.isCheckedIn"
            (click)="selectUser(user)"
          >
            <div class="flex gap-2 justify-between items-center">
              <mat-checkbox
                class="example-margin"
                [disabled]="user.isCheckedIn"
                [checked]="isSelected(user.id)"
              />

              <div class="flex flex-col items-start justify-between">
                <span>{{ user.firstname }},</span>
                <span>{{ user.lastname }}</span>
              </div>
            </div>

            <span>{{ user.email }}</span>
          </div>
        } @empty {
          <div class="h-full w-full flex justify-center items-center">
            <app-no-entries-placeholder />
          </div>
        }
        @if (requestState() === RequestStateEnum.PENDING) {
          <div
            class="absolute flex justify-center items-center top-0 left-0 w-full h-full bg-white bg-opacity-50"
          >
            <app-spinner></app-spinner>
          </div>
        }
      </div>

      @if (showPaginator()) {
        <mat-paginator
          aria-label="Seite auswählen"
          [length]="totalItems()"
          [pageSize]="pageSize()"
          [hidePageSize]="true"
          [pageIndex]="pageIndex()"
          (page)="handlePageEvent($event)"
        />
      }
    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <div class="w-full flex flex-col gap-2">
      @if (requestState() === RequestStateEnum.ERROR) {
        <app-alert
          [type]="AlertTypeEnum.ERROR"
          [message]="alertMsg"
        />
      }

      <app-button
        [text]="buttonText()"
        [disabled]="selectedUsers().length === 0"
        [isLoading]="requestState() === RequestStateEnum.PENDING"
        [fullWidth]="true"
        (clicked)="checkInManually()"
      />
    </div>
  </mat-dialog-actions>
</div>
